import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import styled from "styled-components";
import LoadingSpinner from "components/LoadingSpinner";
import SingleEvent from "components/event/SingleEvent";
import { modifyDocumentTitle } from "components/utils";
import { groupEventsByMonth } from "utils";
import { getAllEvents } from "store/actions";
import HiddenOn from "components/common/HiddenOn";
import Typography from "@material-ui/core/Typography";

const AllEvents = ({ getEvents, loading, events, error, isMobile }) => {
  useEffect(() => {
    getEvents();
  }, [getEvents]);

  modifyDocumentTitle("All Events");

  if (loading) {
    return null;
  }

  const groupedEvents = groupEventsByMonth(events);

  return (
    <div style={{ backgroundColor: "#292b2f" }}>
      <HiddenOn hideOn={loading} fallback={<LoadingSpinner />}>
        <HiddenOn
          hideOn={error}
          fallback={
            <ErrorBox>
              <div>There was an error fetching the latest events.</div>
              <div>Please try again later.</div>
            </ErrorBox>
          }
        >
          <Wrapper>
            <Typography variant="h3" component="h3">
              <u>All Events</u>
            </Typography>
            <p>All of Combined Arms' events can be found below.</p>
            {groupedEvents.map(({ date, events }: any, index) => {
              return (
                <Wrapper key={index}>
                  <Typography variant="h4" component="h4">
                    {date}
                  </Typography>
                  <EventHolder id={"holder"} isMobile={isMobile}>
                    {events.map(
                      ({
                        event_id,
                        event_date,
                        event_owner,
                        event_repo,
                        event_title,
                      }) => (
                        <SingleEvent
                          key={event_id}
                          event_id={event_id}
                          event_date={event_date}
                          event_owner={event_owner}
                          event_repo={event_repo}
                          event_title={event_title}
                        />
                      )
                    )}
                  </EventHolder>
                </Wrapper>
              );
            })}
          </Wrapper>
        </HiddenOn>
      </HiddenOn>
    </div>
  );
};

const Wrapper = styled.div`
  border-style: solid;
  border-color: #3b618ccc;
  border-radius: 8px;
  background-color: #292b2f;
  border-width: 2px;
  padding: 5px;
  margin: 10px;
`;

const EventHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  place-content: ${(props) => (!!props.isMobile ? "center" : "unset")};
  > a {
    width: 200px;
    background-color: #36393f;
    border-radius: 5px;
    padding-top: 5px;
    color: #d3d3d4;
    padding: 5px;
    margin: 10px;
  }
`;

const ErrorBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  place-content: center;
  flex-direction: column;
`;

export const EventMonthWrapper = styled.div`
  border-style: solid;
  border-color: #3b618ccc;
  border-radius: 8px;
  background-color: #36393f;
  border-width: 2px;
  padding: 5px;
  margin: 10px;
`;

const mapDispatchToProps = {
  getEvents: getAllEvents,
};

const mapStateToProps = (state) => ({
  events: get(state, "rootReducer.orbat.openEvents.events", []),
  error: get(state, "rootReducer.orbat.openEvents.error"),
  loading: get(state, "rootReducer.orbat.openEvents.loading"),
  isMobile: get(state, "rootReducer.core.isMobile", false),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllEvents);
